{
  "until": "{{prayer}} vaktine {{duration}}",
  "begin_focus": "Odaklanmaya başla",
  "add_task": "Görev ekle",
  "more_tasks": "+{{count}} daha",
  "fajr_at": "İmsak: {{time}}",
  "schedule_title": "Bugün",
  "plan_my_day": "Günümü planla",
  "planning": "Planlanıyor…",
  "suggested": "Önerilen",
  "keep_plan": "Planı koru",
  "undo_plan": "Geri al",
  "plan_error": "Şu an planlanamadı. Tekrar deneyin.",
  "plan_empty": "Henüz planlanacak bir şey yok — önce bir görev ekleyin.",
  "plan_settled": "Her şey zaten yerli yerinde.",
  "view_list": "Liste",
  "view_switch_aria": "Liste ve gün görünümü arasında geçiş yap",
  "unassigned": "Planlanmamış",
  "assign_title": "Namaz bloğu",
  "no_block": "Blok yok",
  "assign_aria": "Bir namaz bloğuna ata",
  "open_schedule_aria": "Bugünün programını aç",
  "focus_session_label": "{{block}} · Odak",
  "block_hero": "{{prayer}} vaktine kadar derin çalışma",
  "moments_away": "{{prayer}} vakti çok yakın",
  "block_clear": "Her şey tamam — {{prayer}} vaktine kadar dinlenin",
  "alhamdulillah": "Elhamdülillah",
  "exit_hint": "Sessizce çıkmak için Esc",
  "exit_hint_touch": "Sessizce çıkmak için ✕'e dokunun",
  "mark_done_aria": "Görevi tamamlandı olarak işaretle",
  "quick_add_placeholder": "Bu bloğa ekle…",
  "focus_task_aria": "Bu göreve odaklan"
}
